import type { UnifiedSessionState } from '@modelcast/types';

export function getSessionEndTargetForViewer(
  roomCode: string,
  participantId: string | null,
  state: Pick<UnifiedSessionState, 'modelParticipantIds'> | null | undefined
) {
  const viewerIsModel = Boolean(participantId && state?.modelParticipantIds.includes(participantId));
  return viewerIsModel ? `/s/${roomCode}/packs` : `/s/${roomCode}/summary`;
}
